import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import CyberComponent from "containers/CyberComponent";
import { Form } from "react-bootstrap";
import RequestControls from "containers/request/RequestControls";
import Instructions from "containers/request/OTA/OTADeviceInfoBubble";
import RequestManufacturer from "components/request/RequestManufacturer";
import RequestModelName from "components/request/RequestModelnameSimple";
import RequestRevision from "components/request/RequestRevision";
import NonSarSites from "containers/request/battery/NonSarSites/NonSarSites";
import NonSarSitesReadonly from "containers/request/battery/NonSarSites/NonSarSitesReadonly";
import SubmissionDetails from "containers/request/RequestContent/SubmissionDetails";
import { setValue, setBatteryRequestPermissions } from "actions/request";
import { initACR, updateDeviceInfoACR } from "actions/battery/acrRequest";
import { mapNonSarManufSites } from "actions/battery/batteryRequests";
import { submitWizardStep } from "actions/wizard";
import { ifModelExists } from "actions/model";
import { hasStringValue } from "helpers/RequestHelper";
import { getRequestOwner } from "helpers/UsersHelper";

class RequestContainerACR extends CyberComponent {
  updatePermissions = () => {
    const { request, user, setBatteryRequestPermissions } = this.props;
    setBatteryRequestPermissions(request, user);
  };

  componentDidMount() {
    const { request, user } = this.props;

    // fetch only for the first time on submissions
    if (!this.isValidToSubmit() && !request.id) {
      this.props.initACR();
    }

    // fetch for existed requests
    if (request.id) {
      const companyid = user.isStaff ? request.submitter.companyid : null;
      this.props
        .initACR(companyid)
        .then(() => this.props.mapNonSarManufSites(request.linkedManufsites));
    }

    this.updatePermissions();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user.togglerEnabled !== this.props.user.togglerEnabled) {
      this.updatePermissions();
    }
  }

  onSaveClick = () => {
    const {
      request,
      sites,
      user,
      ifModelExists,
      updateDeviceInfoACR
    } = this.props;

    const modelNameUntouched =
      request.modelName === request.__orig.vendorproductname;

    if (!modelNameUntouched) {
      const ownerId = getRequestOwner(request, user);

      ifModelExists(request.modelName, ownerId).then(isUnique => {
        // allow to update in case only modelname is unique
        if (isUnique) {
          updateDeviceInfoACR(request, sites.nonSarSites);
        }
      });
    } else {
      updateDeviceInfoACR(request, sites.nonSarSites);
    }
  };

  onContinueClick = () => {
    const { request, user, ifModelExists } = this.props;

    ifModelExists(request.modelName, user.companyid).then(isUnique => {
      if (isUnique) {
        return this.props.submitWizardStep();
      }
    });
  };

  validateModel() {
    return hasStringValue(this.props.request, "modelName");
  }

  validateRevision() {
    return hasStringValue(this.props.request, "revision");
  }

  validateManufSites() {
    const { sites } = this.props;

    return sites && sites.nonSarSites && _.some(sites.nonSarSites, "checked");
  }

  isValidToSubmit() {
    const { canEditDeviceInfo } = this.props.user;

    // don't need to validate if form is non-editable
    if (canEditDeviceInfo === false) return true;

    // check if all required fields are valid
    return (
      this.validateModel() &&
      this.validateRevision() &&
      this.validateManufSites()
    );
  }

  render() {
    const { canEditDeviceInfo } = this.props.user;
    const saveHandler = canEditDeviceInfo ? this.onSaveClick : null;
    const isEditable = { editable: canEditDeviceInfo };
    const isValid = this.isValidToSubmit();

    return (
      <div>
        <Instructions />
        <Form horizontal>
          <RequestManufacturer />
          <RequestModelName />
          <RequestRevision fieldId="revision" {...isEditable} />
          <SubmissionDetails />
          <hr />
          {canEditDeviceInfo ? <NonSarSites /> : <NonSarSitesReadonly />}
          <RequestControls
            isValidToSubmit={this.isValidToSubmit()}
            isValid={isValid}
            onSave={saveHandler}
            onContinue={this.onContinueClick}
          />
        </Form>
      </div>
    );
  }
}

function mapStateToProps({ app, request, user, sites }) {
  return { app, request, user, sites };
}

export default connect(mapStateToProps, {
  initACR,
  submitWizardStep,
  updateDeviceInfoACR,
  setValue,
  setBatteryRequestPermissions,
  mapNonSarManufSites,
  ifModelExists
})(RequestContainerACR);
